import React from "react";

import { format } from "date-fns-tz";

import { useHistory } from "react-router-dom";

import styles from "./GameItemSm.module.scss";
import { CMS_ASSET_URL_BASE } from "../../../../config";
import { useSelector, useDispatch } from "react-redux";
import {
  adobeGameClickTracking,
  adobeProductTracking,
} from "../../../../helpers/tracking";
import { setGroupGameSelected } from "../../../../features/singleGroup/singleGroupSlice";

export const GameItemSm = (props) => {
  const { game } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { type, currentPage, currentTab } = useSelector(
    (state) => state.singleGroup
  );

  const gamesType = type === "single" ? "Single Game" : "Group";

  const buildUrl = (cmsUrl) => {
    if (!cmsUrl) return "";
    var url = new URL(cmsUrl);

    const IFRAME_MCMID = window.MCMID;
    const IFRAME_MCORGID = window.MCORGID;
    const IFRAME_TS = `TS=${Date.now()}`;
    const CMS_URL_PARAMS = url.search.replace("?", "");
    const CMS_URL_PATHNAME = url.pathname;
    const hasParams =
      CMS_URL_PARAMS || IFRAME_MCMID || IFRAME_MCORGID || IFRAME_TS;
    const hasIframeParams = IFRAME_MCMID || IFRAME_MCORGID || IFRAME_TS;

    const paramsConnector =
      CMS_URL_PARAMS && IFRAME_MCMID ? "&adobe_mc=" : "adobe_mc=";

    const iframeParams = hasIframeParams
      ? paramsConnector + IFRAME_MCMID + "&" + IFRAME_MCORGID + "&" + IFRAME_TS
      : "";

    console.table({
      MCMID: IFRAME_MCMID,
      MCORGID: IFRAME_MCORGID,
      TS: IFRAME_TS,
      "url params": CMS_URL_PARAMS,
      "url hash": url.hash,
    });
    var link = `${url.origin}${CMS_URL_PATHNAME}${
      hasParams ? "?" : ""
    }${CMS_URL_PARAMS}${iframeParams}${url.hash}`;
    return link;
  };
  const groupGameLinkClickHandler = (game) => {
    const products = `Washington Nationals;${
      game?.opponent?.name
    } at Nationals-${format(new Date(game?.date), "MM/dd/yyyy")} ${format(
      new Date(game?.date),
      "HH:mm"
    )};`;

    adobeProductTracking({
      pageName: `Washington Nationals: Tickets: Nationals Ticketfinder: Group Tickets: Ticket Single Group Checkout`,
      products,
    });

    dispatch(setGroupGameSelected(game));

    history.push({
      pathname: "/ticket-single-group/group-select-your-seats",
    });
  };
  const singleGameLinkClickHandler = () => {
    const prop13 = `Washington Nationals: Tickets: Nationals Ticketfinder: ${gamesType} Tickets: ${currentPage}`;
    const prop14 = `${gamesType} Tickets: ${currentPage}: ${currentTab}: vs. ${game.opponent.name} Click`;
    const eVar40 = `${game.opponent.name} at Washington Nationals: ${format(
      new Date(game.date),
      "MMM"
    )} ${format(new Date(game.date), "d")}, ${format(
      new Date(game.date),
      "y"
    )}`;
    const prop40 = `${game.opponent.name} at Washington Nationals: ${format(
      new Date(game.date),
      "MMM"
    )} ${format(new Date(game.date), "d")}, ${format(
      new Date(game.date),
      "y"
    )}`;

    const prop44 = `<gamePK>`;
    adobeGameClickTracking({
      prop13,
      prop14,
      eVar40,
      prop40,
      prop44,
    });

    const url =
      type === "single" ? buildUrl(game.url_single) : buildUrl(game.url_group);
    if (url.includes("undefined")) {
      window.open(
        type === "single" ? game.url_single : game.url_group,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };
  const linkClickHandler = () => {
    if (!game) return;
    // console.log(
    //   "🚀 ~ file: GameItemSm.js:107 ~ linkClickHandler ~ game:",
    //   game
    // );

    if (type === "single") {
      singleGameLinkClickHandler();
    } else {
      groupGameLinkClickHandler(game);
    }
  };

  return (
    <div className={styles.game} onClick={linkClickHandler}>
      <div className={styles.date}>
        <span>{format(new Date(game.date), "EEE")}</span>
        <span>{format(new Date(game.date), "MMM")}</span>
        <span>{format(new Date(game.date), "d")}</span>
      </div>
      <div className={styles.content}>
        <div className={styles.opponent}>
          <div className={styles.logo}>
            <img
              src={`${CMS_ASSET_URL_BASE}${game.opponent.logo?.path}`}
              alt="team logo"
            />
          </div>
          <div className={styles.info}>
            <div className={styles.name}>vs. {game.opponent.name}</div>
            <div className={styles.time}>
              {format(new Date(game.date), "p")}
            </div>
            {game?.desc && <div className={styles.desc}>{game?.desc}</div>}
            {game?.giveaway_desc && (
              <div className={styles.desc}>{game?.giveaway_desc}</div>
            )}
          </div>
        </div>
        <div className={styles.extraInfo}>
          {game.img?.path && (
            <div className={styles.promoImg}>
              <img src={`${CMS_ASSET_URL_BASE}${game.img?.path}`} alt=" " />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
